<template>
  <div class="pa-4 pb-2">
    <v-container grid-list-xl fluid class="pa-0 px-1">
      <!-- <v-layout row wrap class="pr-2 pl-2">
        <v-flex xs12 sm8 md8 lg8 mb-3 class="pb-0 pa-0">
          <h3 class="darkblue--text breadcrumbs font-weight-700 fs-16 lh-16">
            POWER BI
          </h3>
        </v-flex>
      </v-layout> -->
      <iframe
        width="100%"
        height="600"
        :src="iframeURL"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PowerBI',
  computed: {
    ...mapState('powerBI', ['urls', 'url']),
    iframeURL() {
      return this.url
        ? `${this.url.url}&filterPaneEnabled=false&filter=ProfileMapping%2Fid_profile_login%20eq%20${localStorage.profile_id}`
        : '';
    }
  },
  data: () => ({}),
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.$store.dispatch('powerBI/get', {
        profile_id: localStorage.profile_id
      });
    }
  }
};
</script>
